import {useContext, useEffect} from "react";
import "./Cursor.scss";
import StyleContext from "../../contexts/StyleContext";
import gsap, {TweenLite} from "gsap";

gsap.registerPlugin();

const Cursor = () => {
  const {isDark} = useContext(StyleContext);

  useEffect(() => {
    var cursor = document.querySelector(".custom-cursor");

    TweenLite.set(cursor, {
      xPercent: -49,
      yPercent: -45.6
    });

    const handleMouseMove = e => {
      TweenLite.to(cursor, 0.3, {
        x: e.clientX,
        y: e.clientY
      });
    };

    window.addEventListener("mousemove", handleMouseMove);

    const links = document.querySelectorAll("a");
    links.forEach(link => {
      link.addEventListener("mouseenter", () =>
        cursor.classList.add("hovered")
      );
      link.addEventListener("mouseleave", () =>
        cursor.classList.remove("hovered")
      );
    });

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      links.forEach(link => {
        link.removeEventListener("mouseenter", () =>
          cursor.classList.add("hovered")
        );
        link.removeEventListener("mouseleave", () =>
          cursor.classList.remove("hovered")
        );
      });
    };
  }, []);

  return (
    <div className="custom-cursor">
      <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        xmlns="http://www.w3.org/2000/svg"
        className="cursor-text"
      >
        <defs>
          <path
            id="fullCircle"
            d="
          M80,80
          m-40,0
          a40,40 0 1,0 80,0
          a40,40 0 1,0 -80,0
        "
          />
        </defs>

        <text
          fontSize="10"
          fill={isDark ? "#fff" : "#000"}
          fontFamily="sans-serif"
          textLength="240"
        >
          <textPath href="#fullCircle" startOffset="0%">
            <tspan fill="" dx="6">
              •
            </tspan>

            <tspan dx="6">t</tspan>
            <tspan dx="0">e</tspan>
            <tspan dx="0">c</tspan>
            <tspan dx="0">h</tspan>
            <tspan dx="0">r</tspan>
            <tspan dx="0">o</tspan>
            <tspan dx="0">m</tspan>
            <tspan dx="0">e</tspan>
            <tspan dx="0">o</tspan>

            <tspan dx="6">•</tspan>

            <tspan dx="6">s</tspan>
            <tspan dx="0">o</tspan>
            <tspan dx="0">f</tspan>
            <tspan dx="0">t</tspan>
            <tspan dx="0">w</tspan>
            <tspan dx="0">a</tspan>
            <tspan dx="0">r</tspan>
            <tspan dx="0">e</tspan>

            <tspan dx="6">•</tspan>

            <tspan dx="6">e</tspan>
            <tspan dx="0">n</tspan>
            <tspan dx="0">g</tspan>
            <tspan dx="0">i</tspan>
            <tspan dx="0">n</tspan>
            <tspan dx="0">e</tspan>
            <tspan dx="0">e</tspan>
            <tspan dx="0">r</tspan>
          </textPath>
        </text>
      </svg>
    </div>
  );
};

export default Cursor;
